/**
 * Menu script
 */
class Mokolove_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuBlock = this.menuWrapper.find('.menu-block');
        this.menuBlockItem = this.menuBlock.find('.menu-item.menu-item-has-children');
        this.menuSidebar = $('.sidebar .menu');
        this.menuSidebarItem = this.menuSidebar.find('.menu-item.menu-item-has-children');
        this.menuSidebarItemAncestor = this.menuSidebar.find('.menu-item.current-menu-ancestor');
        this.desktopViewport = window.matchMedia('(min-width: 1040px)');
    }

    initEvents() {
        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 80 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 80 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.desktopViewport.matches) {
            this.menuBlockItem.attr('aria-expanded', 'false');

            for (let i = 0; i < this.menuBlockItem.length; i++) {
                this.menuBlockItem.eq(i).on('click', e => {
                    let menuItemValue = this.menuBlockItem.eq(i).attr('aria-expanded');

                    this.menuBlockItem.attr('aria-expanded', 'false');
                    this.menuBlockItem.eq(i).attr('aria-expanded', 'true');

                    if (  menuItemValue === 'true' ) {
                        this.menuBlockItem.eq(i).attr('aria-expanded', 'false');
                    }
                });
            }
        }

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                let menuIconValue = this.menuIcon.attr('aria-expanded');
                this.menuBlock.toggleClass('is-active');
                this.menuWrapper.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                this.menuIcon.attr('aria-expanded', 'true');
                
                $(document.body).toggleClass('no-scroll');

                if ( menuIconValue === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }

                setTimeout(() => {
                    this.menuBlock.toggleClass('is-showing');
                }, 150);
            });
        }

        this.menuSidebarItemAncestor.addClass('active');
        
        this.menuSidebarItem.each(function(i, item) {
            $(item).on("click", function () {
                var item = $(this);
                $(this).parent().find('.menu-item').removeClass('active');
                item.addClass('active');
            });
        });
    }
}
